import styled from "styled-components";
import {theme} from "../../assets/styles/theme.styles";

export const CircleIcon = styled.div`
  background-color: ${theme.colors.color2};
  border-radius: 50%;
`;